module.exports = __webpack_public_path__ + "e8dd12b3323a2c4e927caf4eb995ab90.png";